/* eslint-disable @next/next/no-img-element */
import React from "react";

function TextChartLoader() {
    return (
        <div className='chartDataTile'>
            <div className="loader">
                <img src="/images/loading-gif.gif" alt="loader_image" />
                <span>Loading data</span>
            </div>
        </div>
    );
}

export default TextChartLoader;
